export enum ScreenType {
  login = "login",
  hall = "hall",
  player = "player",
  creator = "creator",
  roomlist = "room-list",
  leaderboard = "leader-board",
  createChallenge = "create-challenge",
  setupChallenge = "setup-challenge",
  profile = "profile"
}
